import { NoticeProps } from '@components/pages/important-notices/Notice'

const notices: NoticeProps[] = [
  {
    details:
      'Starting May 7, 2025, please ensure you have your REAL ID or other Acceptable Form of ID (for example, a passport) prior to traveling or you may encounter delays at the (airport) checkpoint.',
  },
  // {
  //   headline: 'Weather-Related Closures',
  //   details: `
  //    IAH, HOU & MSY closed Jan 21st due to severe weather
  //   `,
  //   date: '01/21/2025',
  //   id: 'health-and-wellness',
  // },
]

export default notices
